import { DEFAULT_LANGUAGE_CODE } from "@nf/constants";

export const formatCurrency = (
  amount: number | null,
  currency: string,
  locale: string = DEFAULT_LANGUAGE_CODE
) => {
  if (amount === null) {
    return (0)
      .toLocaleString(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
      })
      .replace(/\d/g, "")
      .trim();
  }

  return amount.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
  });
};
